/**
 * Module dependencies.
 */

import {
  Characteristics,
  CharacteristicsWrapper,
  Content,
  Image,
  Info,
  StyledSubTitle,
  Wrapper,
} from './product-description.style';

import { Container } from '@mui/material';
import { DownloadArea } from './download-area';
import { JSX } from 'react';
import { OtherCategoryModels } from '../other-category-models/other-category-models';
import { Paragraph } from '../footer/footer.style';
import { ProductTechnicalInformation } from './product-technical-information';
import { useTranslation } from 'next-i18next';

/**
 * `Props` type.
 */

type Props = {
  catalogCategories: any;
  product: any;
};

/**
 * Export `ProductDescription` component.
 */

export function ProductDescription(props: Props): JSX.Element {
  const { catalogCategories, product } = props;
  const { i18n, t: translate } = useTranslation();
  const lang = i18n.language;

  return (
    <Container>
      <Wrapper>
        <OtherCategoryModels
          catalogCategories={catalogCategories}
          productId={product.id}
        />

        <Content noCharacteristics={!product.characteristics?.[lang]}>
          {product.image && <Image area={'image'} image={product.image} />}

          {product.technicalImage && (
            <Image area={'technicalImage'} image={product.technicalImage} />
          )}

          {!!product.characteristics?.[lang] && (
            <CharacteristicsWrapper>
              <StyledSubTitle>
                {translate('catalog.products.characteristics')}
              </StyledSubTitle>

              <Characteristics>
                {product.characteristics?.[lang]}
              </Characteristics>
            </CharacteristicsWrapper>
          )}

          <Info>
            <StyledSubTitle small>
              {product.technicalDescription?.[lang]}
            </StyledSubTitle>

            <Paragraph>
              {product.titleDownloadZone?.[lang] ??
                translate('catalog.products.technicalDescription')}
            </Paragraph>

            <ProductTechnicalInformation product={product} />

            <DownloadArea product={product} />
          </Info>
        </Content>
      </Wrapper>
    </Container>
  );
}
